import {useEffect, useState} from 'react';
import {Modal} from "@tag/tag-components-react-v4";
import AppGroupService from "../../APP/services/AppGroupService";
import { ProjectAccents } from "../../General/config/projectAccents";
import EnvironmentService from "../services/EnvironmentService";
import EnvironmentSelector from "../components/EnvironmentSelector";
import {AppEnvironment} from "../types/AppEnvironment";

function APPOctoSyncAllModal(props: { visible: boolean, handleClose: Function, setAlert: Function, setLoading: Function }) {
    const [environments, setEnvironments] = useState<AppEnvironment[]>([]);
    const [selectedSite, setSelectedSite] = useState<string>('');

    useEffect(() => {
        EnvironmentService.getEnvironments()
            .then(environmentOptions => {
                setEnvironments(environmentOptions);
                const defaultEnvironment = environmentOptions.find(environment => environment.isDefault)
                    ?? environmentOptions[0];
                setSelectedSite(defaultEnvironment?.name ?? '');
            })
            .catch(() => setEnvironments([]));
    }, []);

    const renderModalContent = () => {
        let modalContent;
        const siteDescription = environments.length > 1
            ? selectedSite || 'the selected corporate site'
            : 'one environment which sits under one corporate site e.g. Production';

        modalContent = (
            <div>
                <p>
                    Please note, <strong>Syncing All</strong> on {siteDescription},
                    will remove all <strong>Octopus Tenants</strong> that come from other environments which use the same octopus instance,
                    and have their own CorpSite e.g. AcrStaging.
                </p>
                <p>
                    Until we find a solution around this, you should do a sync all on the largest set (production) then
                    sync each individual app group on the smaller set (AcrStaging) when you need to 'sync all' to make sure no tenants are lost.
                </p>
            </div>
        )
        
        return modalContent;
    }
    
    const handleOctopusSyncAll = () => {
        if (environments.length > 1 && !selectedSite) {
            return;
        }

        props.setLoading(true);
        AppGroupService.octopusSyncForAll(selectedSite || undefined)
            .then(() => {
                props.setLoading(false);
                props.setAlert({type: 'success', message: 'All environments synced without issue'});
                props.handleClose();
            })
            .catch((response) => {
                props.setLoading(false);
                props.setAlert({type: 'error', message: 'There was an issue with the sync, please investigate'});
                props.handleClose();
            })
    }

    let content;
    content = <>
        <Modal
            visible={props.visible}
            accent={ProjectAccents.PeoplePlanner}
            heading={'Are you sure you want to sync all App Groups?'}
            onCancelButtonClick={() => {
                props.handleClose();
            }}
            onPrimaryButtonClick={() => handleOctopusSyncAll()}
            primaryButtonProps={{disabled: environments.length > 1 && !selectedSite}}
            onClose={() => props.handleClose()}
        >
            <div>
                <EnvironmentSelector
                    environments={environments}
                    selected={selectedSite}
                    onChange={setSelectedSite}
                />
                {renderModalContent()}
            </div>
        </Modal>
    </>

    return (
        <>
            {content}
        </>
    )

}

export default APPOctoSyncAllModal;
